/* Progressive enhancement only. Purchases, contact, login and orders stay native Shopify. */
(() => {
 'use strict';
 const $ = (s,r=document) => r.querySelector(s);
 const $$ = (s,r=document) => [...r.querySelectorAll(s)];
 const text = JSON.parse($('#LumaiaStrings')?.textContent || '{}');
 const design = Boolean(window.Shopify?.designMode || document.body.classList.contains('design-mode'));
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const controllers = new WeakMap();
 let sequence = null;

 function bind(root,setup) {
  if(controllers.has(root)) return;
  const abort = new AbortController();
  const disposers = [];
  const on=(el,event,fn,options={})=>el?.addEventListener(event,fn,{...options,signal:abort.signal});
  setup(on,disposers);
  controllers.set(root,()=>{abort.abort();disposers.forEach(fn=>fn());controllers.delete(root);});
 }

 function destroy(root) {
  [root,...$$('*',root)].forEach(el=>controllers.get(el)?.());
 }

 const pad=n=>String(n).padStart(2,'0');
 const rootURL=document.body.dataset.root || '/';
 if (document.querySelector('[data-duo-editor]')) {
  sessionStorage.setItem('lumaiaDuoPath', location.pathname);
}

 function initHeader(root) {
  bind(root,(on,dispose)=>{
   const toggle=$('[data-menu-toggle]',root),menu=document.getElementById(toggle?.getAttribute('aria-controls'));
   const productBack = document.querySelector(
  '[data-product-section] .back-to-collection'
);


if (productBack && toggle) {
  toggle.setAttribute('aria-expanded', 'true');
  toggle.setAttribute('aria-label', 'Retour à la collection');
}

const cartPage = document.body.classList.contains('template-cart');

if (cartPage && toggle) {
  toggle.setAttribute('aria-expanded', 'false');
  toggle.setAttribute('aria-label', 'Fermer le panier');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      toggle.setAttribute('aria-expanded', 'true');
    });
  });
}

   const close=()=>{if(!menu)return;menu.hidden=true;document.body.classList.remove('menu-open');toggle.setAttribute('aria-expanded','false');};
   const open=()=>{menu.hidden=false;document.body.classList.add('menu-open');toggle.setAttribute('aria-expanded','true');$('a',menu)?.focus();};

   
on(toggle, 'click', () => {
  if (document.body.classList.contains('template-cart')) {
  const origin = sessionStorage.getItem('lumaiaCartOrigin') || rootURL;
  const duoPath = sessionStorage.getItem('lumaiaDuoPath');

  const originPath = new URL(origin, location.origin).pathname;
  const isDuo = Boolean(
    duoPath &&
    originPath.replace(/\/$/, '') === duoPath.replace(/\/$/, '')
  );

  sessionStorage.removeItem('lumaiaCheckoutReturn');
  sessionStorage.removeItem('lumaiaDuoPath');
  sessionStorage.removeItem('lumaiaCartOrigin');

  window.location.assign(isDuo ? rootURL : origin);
  return;
}

  const cart = document.getElementById('LumaiaCartDrawer');


  // Le panier est prioritaire : la croix le ferme.
  if (cart?.open) {
    cart.close();
    return;
  }

  const productBack = document.querySelector(
    '[data-product-section] .back-to-collection'
  );

  // Revenir au panier si cette fiche a été ouverte depuis celui-ci.
if (productBack) {
  const saved = sessionStorage.getItem('lumaiaProductReturn');

  if (saved) {
    sessionStorage.removeItem('lumaiaProductReturn');

    try {
      const source = JSON.parse(saved);

      if (source.productPath === location.pathname && source.returnUrl) {
  window.location.assign(source.reopenPanel ? '/cart' : source.returnUrl);
  return;
}
    } catch (error) {
      console.warn('Retour panier indisponible', error);
    }
  }

  productBack.click();
  return;
}

  if (cart?.open) {
  document.body.classList.add('cart-to-menu');

  cart.close();
  open();

  setTimeout(() => {
    document.body.classList.remove('cart-to-menu');
  }, 650);

  return;
}

  menu.hidden ? open() : close();
});
   on(menu,'click',e=>{if(e.target.closest('a'))close();});
   on(document,'keydown',e=>{
    if(!menu || menu.hidden)return;
    if(e.key==='Escape'){close();toggle.focus();}
    if(e.key==='Tab'){
     const nodes=[toggle,...$$('a,button',menu)].filter(n=>!n.hidden);
     const i=nodes.indexOf(document.activeElement);
     if(e.shiftKey && i===0){e.preventDefault();nodes.at(-1)?.focus();}
     else if(!e.shiftKey && i===nodes.length-1){e.preventDefault();toggle.focus();}
    }
   });

   const lines=$$('.announcement-line',root);
   lines.forEach((line,i)=>line.setAttribute('aria-hidden',String(i!==0)));
   let current=0;

   if(lines.length>1 && !reduced.matches && !design){
    const timer=setInterval(()=>{
     if(document.hidden || document.body.classList.contains('menu-open'))return;
     const previous=lines[current];
     current=(current+1)%lines.length;
     lines.forEach(n=>n.classList.remove('is-exiting'));
     previous.classList.remove('is-current');
     previous.classList.add('is-exiting');
     previous.setAttribute('aria-hidden','true');
     lines[current].classList.add('is-current');
     lines[current].removeAttribute('aria-hidden');
    },Number(root.dataset.announcementDelay)||7000);
    dispose.push(()=>clearInterval(timer));
   }

   dispose.push(close);
  });
 }

 function createMenu(scenes=[]) {
  const destination=$('[data-scene-menu]');
  if(!destination)return;
  destination.replaceChildren();
  const defaults=text.default_nav || [];
  const items=scenes.length?scenes.map(s=>({anchor:s.dataset.anchor,label:s.dataset.label})):defaults;

  items.forEach((item,i)=>{
   const a=document.createElement('a');
   a.href=`${rootURL}#${item.anchor}`;
   const number=document.createElement('span');
   number.textContent=pad(i+1);
   a.append(number,document.createTextNode(item.label));
   destination.append(a);
  });
 }

 function initSequence() {
  
  const main=$('#MainContent');
  const scenes=$$('[data-scene]',main);
  createMenu(scenes);
  if(document.body.dataset.template!=='index' || design || scenes.length===0)return;

  const wrappers=[...main.children].filter(n=>n.classList.contains('shopify-section'));

  if(wrappers.some(n=>!$('[data-scene]',n))){
   document.body.classList.add('vertical-home');
   return;
  }

  const viewport=document.createElement('div');
viewport.className='viewport';

const track=document.createElement('div');
track.className='section-track';
track.dataset.enhanced='true';

const initialHash=decodeURIComponent(location.hash.slice(1));

let initialIndex=scenes.findIndex(scene=>
 scene.dataset.anchor===initialHash ||
 (initialHash && scene.querySelector(`#${CSS.escape(initialHash)}`))
);

if(initialIndex<0){
 const message=$('.native-contact .form-success,.native-contact .form-error');
 if(message)initialIndex=scenes.findIndex(scene=>scene.contains(message));
}

initialIndex=Math.max(0,initialIndex);

/* Positionner directement la bonne section, sans animation */
track.style.transition='none';
track.style.transform=`translateX(${-initialIndex*100}%)`;

wrappers.forEach(w=>track.append(w));
viewport.append(track);
main.append(viewport);

  const nav=document.createElement('div');
  nav.className='section-navigation';
  nav.innerHTML='<div class="section-current"><span class="section-number"></span><span class="nav-divider"></span><span class="section-name"></span></div><div class="section-dots"></div><div class="section-controls"><button class="circle-button" data-section-prev type="button"></button><button class="circle-button" data-section-next type="button"></button></div>';

  $('[data-section-prev]',nav).textContent=document.body.dataset.previous;
  $('[data-section-next]',nav).textContent=document.body.dataset.next;

  const dots=$('.section-dots',nav);
  dots.setAttribute('aria-label',text.choose_section || 'Sections');

  scenes.forEach((s,i)=>{
   const b=document.createElement('button');
   b.type='button';
   b.setAttribute('aria-label',s.dataset.label);
   b.addEventListener('click',()=>go(i,true));
   dots.append(b);
  });

  main.append(nav);
  document.body.classList.add('sequence-ready');
  let current=initialIndex;

  function syncMobileHeight() {
  if (
  !window.matchMedia('(max-width: 760px)').matches ||
  current < 2
) {
    viewport.style.removeProperty('height');
    return;
  }

  const activeSection = wrappers[current];
  if (!activeSection) return;

  viewport.style.height = `${activeSection.scrollHeight}px`;
}

function go(index,update=false,focus=false) {
 current=Math.max(0,Math.min(index,scenes.length-1));
 document.body.classList.toggle(
  'mobile-flow-page',
  window.matchMedia('(max-width: 760px)').matches && current >= 2
);

 if(update){
  track.style.removeProperty('transition');
 }

 track.style.transform=`translateX(${-current*100}%)`;

   scenes.forEach((s,i)=>{
    wrappers[i].inert=i!==current;
    wrappers[i].setAttribute('aria-hidden',String(i!==current));
   });

   $('.section-number',nav).textContent=pad(current+1);
   $('.section-name',nav).textContent=scenes[current].dataset.label;

   [...dots.children].forEach((b,i)=>{
    b.classList.toggle('active',i===current);
    b.setAttribute('aria-current',String(i===current));
   });

   $('[data-section-prev]',nav).hidden=current===0;
   $('[data-section-next]',nav).hidden=current===scenes.length-1;

   document.body.classList.toggle('collection-mode',scenes[current].classList.contains('collection-slide'));

   $$('[data-scene-menu] a').forEach((a,i)=>{
    if(i===current)a.setAttribute('aria-current','page');
    else a.removeAttribute('aria-current');
   });

   if(update)history.replaceState(null,'',`${location.pathname}${location.search}#${scenes[current].dataset.anchor}`);
   if (window.matchMedia('(max-width: 760px)').matches) {
    requestAnimationFrame(() => {
      syncMobileHeight();
      window.scrollTo({ top: 0, behavior: 'instant' });
    });
   }
   if(focus){
    scenes[current].tabIndex=-1;
    scenes[current].focus({preventScroll:true});
   }
  }

  function fromHash() {
   const hash=decodeURIComponent(location.hash.slice(1));
   let index=scenes.findIndex(s=>s.dataset.anchor===hash);

   if(index<0 && hash){
    const target=document.getElementById(hash);
    index=scenes.findIndex(s=>target && s.contains(target));
   }

   if(index<0){
    const message=$('.native-contact .form-success,.native-contact .form-error');
    if(message)index=scenes.findIndex(s=>s.contains(message));
   }

   go(index>=0?index:0);
  }

  $('[data-section-prev]',nav).addEventListener('click',()=>go(current-1,true,true));
  $('[data-section-next]',nav).addEventListener('click',()=>go(current+1,true,true));
  
// Navigation entre les sections avec la molette et le pavé tactile — ordinateur
let wheelAccumulated = 0;
let wheelLockedUntil = 0;
let wheelDirection = 0;

viewport.addEventListener('wheel', e => {
  // Ne rien modifier sur mobile.
  if (window.matchMedia('(max-width: 760px)').matches) return;

  // Garder le zoom du navigateur.
  if (e.ctrlKey || e.metaKey) return;

  // Ne pas naviguer lorsqu'un panneau est ouvert.
  if (
    document.body.classList.contains('menu-open') ||
    document.body.classList.contains('cart-drawer-open') ||
    document.querySelector('.lumaia-preorder-overlay')
  ) return;

  // Préserver le défilement des éléments internes.
  if (e.target.closest(
    'input, textarea, select, [contenteditable="true"], [data-atelier-carousel]'
  )) return;

  const direction = Math.sign(e.deltaY);

  // Ignorer les gestes horizontaux.
  if (!direction || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

  // Laisser défiler les zones internes lorsqu'elles le peuvent.
  let element = e.target;

  while (element && element !== viewport) {
    if (element instanceof HTMLElement) {
      const style = getComputedStyle(element);
      const scrollable = /(auto|scroll)/.test(style.overflowY);

      if (scrollable && element.scrollHeight > element.clientHeight + 2) {
        const canScroll =
          direction > 0
            ? element.scrollTop + element.clientHeight < element.scrollHeight - 2
            : element.scrollTop > 2;

        if (canScroll) return;
      }
    }

    element = element.parentElement;
  }

  e.preventDefault();

  const now = performance.now();

  // Une seule transition à la fois.
  if (now < wheelLockedUntil) return;

  if (direction !== wheelDirection) {
    wheelAccumulated = 0;
    wheelDirection = direction;
  }

  // Normaliser les valeurs souris / pavé tactile.
  const delta = e.deltaMode === 1
    ? Math.abs(e.deltaY) * 16
    : e.deltaMode === 2
      ? Math.abs(e.deltaY) * window.innerHeight
      : Math.abs(e.deltaY);

  wheelAccumulated += delta;

  if (wheelAccumulated < 45) return;

  wheelAccumulated = 0;

  const next = current + direction;

  if (next < 0 || next >= scenes.length) return;

  wheelLockedUntil = now + 850;

  go(next, true);
}, { passive: false });

  // Navigation tactile entre les sections 3 à 6 — mobile uniquement
let sectionSwipeStart = null;

viewport.addEventListener('touchstart', e => {
  if (!window.matchMedia('(max-width: 760px)').matches) return;
  if (current < 2 || e.touches.length !== 1) return;

  // Le carrousel intérieur de l'Atelier conserve son propre swipe.
  if (e.target.closest('[data-atelier-carousel]')) return;

  // Ne pas intercepter les éléments interactifs.
  if (e.target.closest('button, a, input, select, textarea, summary, [role="slider"]')) return;

  sectionSwipeStart = {
    x: e.touches[0].clientX,
    y: e.touches[0].clientY
  };
}, { passive: true });

viewport.addEventListener('touchend', e => {
  if (!sectionSwipeStart || !e.changedTouches.length) return;

  const dx = e.changedTouches[0].clientX - sectionSwipeStart.x;
  const dy = e.changedTouches[0].clientY - sectionSwipeStart.y;

  sectionSwipeStart = null;

  // Ignorer les mouvements verticaux et les petits gestes.
  if (Math.abs(dx) < 55 || Math.abs(dx) <= Math.abs(dy) * 1.3) return;

  if (dx < 0 && current < scenes.length - 1) {
    go(current + 1, true);
  } else if (dx > 0 && current >= 2) {
  go(current - 1, true);
}
}, { passive: true });

viewport.addEventListener('touchcancel', () => {
  sectionSwipeStart = null;
});

  document.addEventListener('click',e=>{
   const a=e.target.closest('a[href]');
   if(!a)return;
   const u=new URL(a.href,location.href);
   if(u.pathname===location.pathname && u.hash){
    const i=scenes.findIndex(s=>`#${s.dataset.anchor}`===u.hash);
    if(i>=0){
     e.preventDefault();
     go(i,true,true);
    }
   }
  });

  window.addEventListener('hashchange',fromHash);

window.addEventListener('resize', syncMobileHeight);

const mobileResizeObserver = new ResizeObserver(() => {
  syncMobileHeight();
});
wrappers.forEach(wrapper => mobileResizeObserver.observe(wrapper));

sequence={go,scenes};
fromHash();

/* Révéler la section après construction de la navigation */
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.documentElement.classList.remove('lumaia-boot');
    track.style.removeProperty('transition');
  });
});
 }

 function initGallery(section) {
  bind(section,(on,dispose)=>{
   const stage=$('.gallery-stage',section),cards=$$('[data-card]',stage),discover=$('[data-discover]',section),controls=$('[data-gallery-controls]',section);

   if(!cards.length){
    stage.dataset.empty='true';
    const empty=$('.collection-empty',section);
    if(empty)empty.hidden=false;
    return;
   }

   let active=0,hoverTimer,previewTimer;
   const wrap=n=>(n+cards.length)%cards.length;
   const cancel=()=>{
    clearTimeout(hoverTimer);
    clearTimeout(previewTimer);
    stage.classList.remove('is-previewing');
   };

   function select(n) {
    cancel();
    active=wrap(n);

    cards.forEach((card,i)=>{
     let slot=i-active;
     if(slot>cards.length/2)slot-=cards.length;
     if(slot<-cards.length/2)slot+=cards.length;
     const shown=Math.abs(slot)<=2;

     card.classList.toggle('is-active',i===active);
     card.classList.toggle('is-away',!shown);
     card.style.setProperty('--slot',slot);
     card.style.setProperty('--scale',i===active?'1':'.86');
     card.style.setProperty('--tilt',slot<0?'15deg':slot>0?'-15deg':'0deg');
     card.style.setProperty('--lift',i===active?'0px':'-6px');
     card.style.zIndex=String(10-Math.abs(slot));
     card.tabIndex=shown?0:-1;
     card.setAttribute('aria-hidden',String(!shown));
    });

    const isMobile = window.matchMedia('(max-width: 760px)').matches;
const galleryIndex = [...document.querySelectorAll('[data-collection-scene]')]
  .indexOf(section);

$('.gallery-counter', section).textContent =
  isMobile && galleryIndex >= 0 && galleryIndex < 2
    ? `Collection ${pad(galleryIndex + 1)} / 02`
    : `${pad(active + 1)} / ${pad(cards.length)}`;
    const href=cards[active].getAttribute('href');
    discover.hidden=!href;

    if(href){
     discover.href=href;
     discover.textContent=`${discover.dataset.label} ${cards[active].dataset.title}`;
    }
   }

   controls.hidden=cards.length<2;

   on(section,'click',e=>{
    const link=e.target.closest('a[data-card],a[data-discover]');
    const anchor=section.closest('[data-scene]')?.dataset.anchor;
    if(e.defaultPrevented || !link || !anchor)return;
    try{
     sessionStorage.setItem(
      'lumaia-return:'+new URL(link.href).pathname,
      anchor
     );
    }catch{}
   });

   on(section,'lumaia:card',e=>{
    const index=cards.indexOf(e.detail);
    if(index>=0)select(index);
   });

   // Sur mobile : les flèches changent de section.
// Sur ordinateur : elles changent de produit.
const mobileGallery = window.matchMedia('(max-width: 760px) and (pointer: coarse)');

const gallerySectionIndex = () => {
  if (!sequence) return -1;

  const scene = section.closest('[data-scene]');
  return sequence.scenes.indexOf(scene);
};

on($('.gallery-previous',section),'click',()=>{
  const index = gallerySectionIndex();

  if (mobileGallery.matches && index >= 0 && index <= 1) {
    if (index > 0) sequence.go(index - 1, true);
    return;
  }

  select(active - 1);
});

on($('.gallery-next',section),'click',()=>{
  const index = gallerySectionIndex();

  if (mobileGallery.matches && index >= 0 && index <= 1) {
    sequence.go(index + 1, true);
    return;
  }

  select(active + 1);
});

   on(stage,'keydown',e=>{
    if(e.key==='ArrowLeft'||e.key==='ArrowRight'){
     e.preventDefault();
     select(active+(e.key==='ArrowRight'?1:-1));
     cards[active].focus({preventScroll:true});
    }
   });

   cards.forEach((card,i)=>{
    on(card,'pointerenter',e=>{
     if(e.pointerType!=='mouse')return;
     cancel();
     if(i!==active){
      hoverTimer=setTimeout(()=>select(i),Number(section.dataset.dwell)||2000);
     }else if(section.dataset.preview==='true'){
      stage.classList.add('is-previewing');
     }
    });

    on(card,'pointerleave',cancel);

    on(card,'focus',()=>{
     if(card.matches(':focus-visible') && !cards[i].classList.contains('is-away'))select(i);
    });

    on(card,'click',e=>{
     if(i!==active){
      e.preventDefault();
      select(i);
     }else if(card.hasAttribute('data-placeholder')){
      e.preventDefault();
     }
    });
   });

   let start=null,moved=false;

   on(stage,'pointerdown',e=>{
    if(e.pointerType==='mouse')return;
    start={x:e.clientX,y:e.clientY};
    moved=false;
   });

   on(stage,'pointermove',e=>{
    if(!start)return;
    const dx=e.clientX-start.x,dy=e.clientY-start.y;
    if(Math.abs(dx)>20 && Math.abs(dx)>Math.abs(dy)){
     moved=true;
     e.preventDefault();
    }
   },{passive:false});

   on(stage,'pointerup',e=>{
    if(start && moved){
     const dx=e.clientX-start.x;
     if(Math.abs(dx)>30)select(active+(dx<0?1:-1));
    }
    start=null;
   });

   on(stage,'click',e=>{
    if(moved){
     e.preventDefault();
     e.stopPropagation();
     moved=false;
    }
   },{capture:true});

   dispose.push(cancel);
   select(0);
  });
 }

 function stepValidation(root) {
  const inputs=$$('input,textarea,select',root);
  const invalid=inputs.find(n=>!n.checkValidity());
  if(invalid){
   invalid.reportValidity();
   return false;
  }
  return true;
 }

 function initCustom(form) {
  bind(form,(on)=>{
   const steps=$$('[data-step]',form),indicators=$$('.custom-stepper>span',form),back=$('[data-form-back]',form),next=$('[data-form-next]',form);
   let current=0;
   form.noValidate=true;
   form.dataset.stepped='true';

   function go(n){
    current=n;
    steps.forEach((s,i)=>s.hidden=i!==n);
    indicators.forEach((s,i)=>s.classList.toggle('active',i===n));
    back.hidden=n===0;
    next.textContent=n===steps.length-1?form.dataset.submit:form.dataset.continue;
   }

   on(form,'lumaia:step',e=>go(Number(e.detail)));
   on(back,'click',()=>go(Math.max(0,current-1)));

   on(form,'change',e=>{
    if(e.target.name!=='stones')return;
    const checked=$$('input[name=stones]:checked',form);
    if(checked.length>Number(form.dataset.stoneLimit)){
     e.target.checked=false;
    }
    const selected=$$('input[name=stones]:checked',form);
    $('[data-stone-count]',form).textContent=`${selected.length} / ${form.dataset.stoneLimit}`;
    $$('input[name=stones]',form).forEach(n=>n.disabled=!n.checked && selected.length>=Number(form.dataset.stoneLimit));
   });

   on(form,'submit',e=>{
    e.preventDefault();
    if(!stepValidation(steps[current]))return;

    if(current<steps.length-1){
     go(current+1);
     $('input,textarea',steps[current])?.focus({preventScroll:true});
     return;
    }

    const phone=form.dataset.phone.replace(/\D/g,'');

    if(!/^\d{8,15}$/.test(phone)){
     $('[data-form-error]',form).textContent=text.whatsapp_error;
     $('[data-form-error]',form).hidden=false;
     return;
    }

    const data=new FormData(form);
    const lines=[
     text.request_title,
     '',
     `${text.first_name} : ${data.get('firstname')} ${data.get('lastname')}`,
     `${text.phone} : ${data.get('phone')}`,
     `${text.location} : ${data.get('location')}`,
     '',
     String(data.get('creation')),
     String(data.get('wishes')),
     '',
     `${text.stones} : ${data.getAll('stones').join(', ') || text.stones_open}`
    ];

    location.assign(`https://wa.me/${phone}?text=${encodeURIComponent(lines.join('\n'))}`);
   });

   go(0);
  });
 }

 function initContact(form) {
  bind(form,(on)=>{
   const steps=$$('[data-contact-step]',form);
   if(steps.length!==2)return;
   form.noValidate=true;
   form.dataset.stepped='true';

   function go(n){
    steps.forEach((s,i)=>s.hidden=i!==n);
   }

   on($('[data-contact-next]',form),'click',()=>{
    if(stepValidation(steps[0])){
     go(1);
     $('textarea',steps[1])?.focus({preventScroll:true});
    }
   });

   on($('[data-contact-back]',form),'click',()=>go(0));

   on(form,'submit',e=>{
    const invalid=$$('input,select,textarea',form).find(n=>!n.checkValidity());
    if(invalid){
     e.preventDefault();
     go(steps.findIndex(s=>s.contains(invalid)));
     invalid.reportValidity();
    }
   });

   go(0);
  });
 }

 function initStory(section) {
  bind(section, (on) => {
    const tabs = $$('[data-story]', section);
    const images = $('.story-images', section);

    const select = (tab) => {
      images.dataset.storyView = tab.dataset.story;

      tabs.forEach(t => {
        const active = t === tab;
        t.setAttribute('aria-selected', String(active));
        t.tabIndex = active ? 0 : -1;

        const panel = document.getElementById(
          t.getAttribute('aria-controls')
        );

        if (panel) panel.hidden = !active;
      });

      $$('.story-photo', images).forEach(photo => {
        photo.setAttribute(
          'aria-hidden',
          String(
            !photo.classList.contains(
              `story-${tab.dataset.story === 'story' ? 'main' : 'atelier'}-image`
            )
          )
        );
      });
    };

    tabs.forEach((tab, i) => {
      on(tab, 'click', () => select(tab));

      on(tab, 'keydown', e => {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
          e.preventDefault();

          const index =
            e.key === 'Home' ? 0 :
            e.key === 'End' ? tabs.length - 1 :
            (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;

          select(tabs[index]);
          tabs[index].focus();
        }
      });
    });

    // Navigation intérieure des deux ateliers
    const carousel = $('[data-atelier-carousel]', section);
    const track = $('[data-atelier-track]', section);

    if (carousel && track) {
      const pages = $$('[data-atelier-page]', carousel);
      const dots = $$('[data-atelier-dot]', carousel);

      let current = 0;
      let start = null;

      function go(index) {
        current = Math.max(0, Math.min(index, pages.length - 1));

        track.style.transform = `translateX(${-current * 100}%)`;

        pages.forEach((page, i) => {
          page.setAttribute('aria-hidden', String(i !== current));
          page.inert = i !== current;
        });

        dots.forEach((dot, i) => {
          const active = i === current;

          dot.classList.toggle('active', active);
          dot.setAttribute('aria-current', String(active));
        });
      }

      dots.forEach((dot, i) => {
        on(dot, 'click', () => go(i));
      });

      // Glissement tactile horizontal
      on(carousel, 'touchstart', e => {
        if (e.touches.length !== 1) return;

        start = {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY
        };
      }, { passive: true });

      on(carousel, 'touchend', e => {
        if (!start || !e.changedTouches.length) return;

        const dx = e.changedTouches[0].clientX - start.x;
        const dy = e.changedTouches[0].clientY - start.y;

        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          go(current + (dx < 0 ? 1 : -1));
        }

        start = null;
      }, { passive: true });

      // Navigation au clavier
      on(carousel, 'keydown', e => {
        if (e.target.closest('[data-atelier-dot]')) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();

            go(current + (e.key === 'ArrowRight' ? 1 : -1));
            dots[current]?.focus();
          }
        }
      });

      // Afficher le premier atelier au chargement
      go(0);
    }

    select(tabs[0]);
  });
}

 function initPan(view) {
  bind(view,(on,dispose)=>{
   const img=$('img',view);
   if(!img)return;
   const product=view.closest('[data-product-section]');
   const enabled=getComputedStyle(product).getPropertyValue('--image-motion').trim()==='1' && !reduced.matches;
   if(!enabled)view.style.cursor='default';

   let box={x:0,y:0,w:0,h:0,frameW:0,frameH:0},timer,drag=null;

   const reset=()=>{
    view.style.setProperty('--pan-x','0px');
    view.style.setProperty('--pan-y','0px');
    view.classList.remove('is-panning','is-dragging');
    drag=null;
   };

   function layout() {
    const w=view.clientWidth,h=view.clientHeight;
    const nw=img.naturalWidth,nh=img.naturalHeight;
    if(!w || !h || !nw || !nh)return;

    const contain=view.dataset.fit==='contain';
    const a=enabled && !contain
     ? Number(getComputedStyle(product).getPropertyValue('--pan-amount')) || 16
     : 0;

    let factor=(contain
     ? Math.min(w/nw,h/nh)
     : Math.max(w/nw,h/nh)
    )*(Number(view.dataset.zoom)/100);

    if(a){
     factor=Math.max(factor,(w+2*a)/nw,(h+2*a)/nh);
    }

    const iw=nw*factor,ih=nh*factor;
    const cx=Number(view.dataset.x)/100;
    const cy=Number(view.dataset.y)/100;
    const clamp=(v,min,max)=>Math.max(min,Math.min(max,v));

    const left=iw<w
     ? (w-iw)/2
     : clamp(w/2-iw*cx,w-iw+a,-a);

    const top=ih<h
     ? (h-ih)/2
     : clamp(h/2-ih*cy,h-ih+a,-a);

    img.style.width=`${iw}px`;
    img.style.height=`${ih}px`;
    img.style.left=`${left}px`;
    img.style.top=`${top}px`;

    box={x:left,y:top,w:iw,h:ih,frameW:w,frameH:h};
    reset();
   }

   const move=(dx,dy)=>{
    if(!enabled)return;
    clearTimeout(timer);
    const a=Number(getComputedStyle(product).getPropertyValue('--pan-amount'))||16;
    const clamp=(v,min,max)=>Math.max(min,Math.min(max,v));
    const x=box.w>=box.frameW?clamp(dx,-box.w+box.frameW-box.x,-box.x):0;
    const y=box.h>=box.frameH?clamp(dy,-box.h+box.frameH-box.y,-box.y):0;

    view.style.setProperty('--pan-x',`${clamp(x,-a,a)}px`);
    view.style.setProperty('--pan-y',`${clamp(y,-a,a)}px`);
    view.classList.add('is-panning');
   };

   on(img,'load',layout);
   const observer=new ResizeObserver(layout);
   observer.observe(view);
   dispose.push(()=>observer.disconnect());

   on(view,'pointermove',e=>{
    if(e.pointerType==='mouse' && !drag){
     const r=view.getBoundingClientRect();
     const a=Number(getComputedStyle(product).getPropertyValue('--pan-amount'))||16;
     move(
      ((e.clientX-r.left)/r.width-.5)*-2*a,
      ((e.clientY-r.top)/r.height-.5)*-2*a
     );
    }else if(drag){
     move((e.clientX-drag.x)*.3,(e.clientY-drag.y)*.3);
    }
   });

   on(view,'pointerdown',e=>{
    if(!enabled)return;
    drag={x:e.clientX,y:e.clientY};
    view.setPointerCapture(e.pointerId);
    view.classList.add('is-dragging');
   });

   on(view,'pointerup',reset);
   on(view,'pointercancel',reset);
   on(view,'pointerleave',reset);
   on(view,'blur',reset);

   on(view,'keydown',e=>{
    const vector={
     ArrowLeft:[16,0],
     ArrowRight:[-16,0],
     ArrowUp:[0,16],
     ArrowDown:[0,-16]
    };

    if(vector[e.key]){
     e.preventDefault();
     move(...vector[e.key]);
     timer=setTimeout(reset,900);
    }
   });

   dispose.push(()=>clearTimeout(timer));
   if(img.complete)layout();
  });
 }

 function initProduct(section) {
  bind(section,(on,dispose)=>{
   const updatePrice=()=>{
    const input=$('input[name="quantity"]',section);
    const price=$('.product-price[data-unit-price]',section);
    if(!input || !price || !input.checkValidity())return;

    const quantity=Number(input.value);
    if(!Number.isInteger(quantity) || quantity<1)return;

    const money=new Intl.NumberFormat(document.documentElement.lang || 'fr',{
     style:'currency',
     currency:price.dataset.currency
    });

    $('[data-quantity-price]',price).textContent=money.format(Number(price.dataset.unitPrice)*quantity/100);

    const compare=$('[data-quantity-compare]',price);
    if(compare)compare.textContent=money.format(Number(price.dataset.comparePrice)*quantity/100);

    price.setAttribute('aria-label',`Prix total pour ${quantity} article${quantity>1?'s':''}`);
   };

   on(section,'input',event=>{
    if(event.target.matches('input[name="quantity"]'))updatePrice();
   });

   on(section,'change',event=>{
    if(event.target.matches('input[name="quantity"]'))updatePrice();
   });

   updatePrice();

   try{
    const anchor=sessionStorage.getItem('lumaia-return:'+location.pathname);
    const back=$('.product-bottom-nav .back-to-collection');
    if(anchor && back)back.href=rootURL+'#'+encodeURIComponent(anchor);
   }catch{}

   let request=null;
   dispose.push(()=>request?.abort());

   on(section,'click',async e=>{
    const link=e.target.closest('[data-option-link]');
    if(!link || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)return;

    const destination=new URL(link.href,location.href);
    if(destination.origin!==location.origin)return;
    if(destination.pathname!==location.pathname)return;

    e.preventDefault();
    request?.abort();
    request=new AbortController();
    section.setAttribute('aria-busy','true');

    const fetchURL=new URL(destination);
    fetchURL.searchParams.set('section_id',section.dataset.sectionId);

    try{
     const response=await fetch(fetchURL,{signal:request.signal});
     if(!response.ok)throw new Error('Variant rendering failed');

     const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
     const replacement=parsed.querySelector('[data-product-section]');
     if(!replacement)throw new Error('Missing product section');

     const optionName=link.textContent;
     const old=section;
     destroy(old);
     old.replaceWith(replacement);
     init(replacement.parentElement);

     destination.searchParams.delete('section_id');

     for(const [key,value] of new URL(location.href).searchParams){
      if(key.startsWith('preview_'))destination.searchParams.set(key,value);
     }

     history.replaceState(null,'',destination.pathname+destination.search);

     const newLink=$$('[data-option-link]',replacement).find(n=>n.textContent===optionName);
     newLink?.focus({preventScroll:true});
    }catch(error){
     if(error.name!=='AbortError')location.assign(destination.href);
    }finally{
     if(section.isConnected)section.removeAttribute('aria-busy');
    }
   });
  });
 }


 function initCountry(form) {
  bind(form,(on)=>{
   const country=$('[data-country-select]',form),province=$('[data-province-select]',form),wrap=$('[data-province-wrap]',form);
   if(!country||!province)return;
   if(country.dataset.default)country.value=country.dataset.default;

   const update=()=>{
    let provinces=[];
    try{
     provinces=JSON.parse(country.selectedOptions[0]?.dataset.provinces||'[]');
    }catch{}

    province.replaceChildren();

    provinces.forEach(([value,label])=>{
     const o=document.createElement('option');
     o.value=value;
     o.textContent=label;
     province.append(o);
    });

    wrap.hidden=provinces.length===0;
    province.disabled=provinces.length===0;
    if(province.dataset.default)province.value=province.dataset.default;
   };

   on(country,'change',update);
   update();
  });
 }

 function init(root=document) {
  const all=(selector)=>[
   ...(root.matches?.(selector)?[root]:[]),
   ...$$(selector,root)
  ];

  all('[data-header]').forEach(initHeader);
  all('[data-collection-scene]').forEach(initGallery);
  all('[data-custom-form]').forEach(initCustom);
  all('.native-contact').forEach(initContact);
  all('[data-story-section]').forEach(initStory);
  all('[data-product-section]').forEach(initProduct);
  all('[data-image-view]').forEach(initPan);
  all('.address-form form').forEach(initCountry);

  all('.faq-list').forEach(list=>bind(list,on=>{
   on(list,'toggle',e=>{
    if(e.target.open){
     $$('details',list).forEach(d=>{
      if(d!==e.target)d.open=false;
     });
    }
   },{capture:true});
  }));
 }

  initSequence();
  init();

 const footerGroups=$$('.shopify-section-group-footer-group');

 if(footerGroups.length){
  const resizeFooter=new ResizeObserver(()=>{
   document.body.style.setProperty(
    '--site-footer-height',
    `${footerGroups.reduce((sum,n)=>sum+n.getBoundingClientRect().height,0)}px`
   );
  });
  footerGroups.forEach(n=>resizeFooter.observe(n));
 }

 const curtain=$('.arrival-curtain');

 if(curtain){
  curtain.addEventListener('animationend',()=>curtain.remove(),{once:true});
  setTimeout(()=>curtain.remove(),5000);
 }

 if(design){
  document.addEventListener('shopify:section:load',e=>{
   init(e.target);
   createMenu($$('[data-scene]'));
  });

  document.addEventListener('shopify:section:unload',e=>destroy(e.target));

  document.addEventListener('shopify:section:select',e=>{
   e.target.scrollIntoView({block:'start',behavior:'auto'});
  });

  document.addEventListener('shopify:section:reorder',()=>{
   createMenu($$('[data-scene]'));
  });

  document.addEventListener('shopify:block:select',e=>{
   const section=e.target.closest('[data-story-section]');

   if(section){
    const atelier=e.target.closest('.process-list');
    $(`[data-story="${atelier?'atelier':'story'}"]`,section)?.click();
   }

   const details=e.target.closest('details');
   if(details)details.open=true;

   const step=e.target.closest('[data-step]');
   if(step){
    step.closest('form').dispatchEvent(new CustomEvent('lumaia:step',{
     detail:step.dataset.step
    }));
   }

   const card=e.target.closest('[data-card]');
   if(card){
    card.closest('[data-collection-scene]').dispatchEvent(new CustomEvent('lumaia:card',{
     detail:card
    }));
   }

   const line=e.target.closest('.announcement-line');
   if(line){
    $$('.announcement-line',line.closest('[data-header]')).forEach(n=>{
     n.classList.toggle('is-current',n===line);
     n.setAttribute('aria-hidden',String(n!==line));
    });
   }
  });
 }

 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-quantity-step]');
  if(!button || button.disabled)return;

  const input=button.closest('.quantity-control')?.querySelector('input');
  if(!input || input.disabled)return;

  const previous=input.value;

  if(button.dataset.quantityStep==='1')input.stepUp();
  else input.stepDown();

  if(input.value===previous)return;

  input.dispatchEvent(new Event('input',{bubbles:true}));
  input.dispatchEvent(new Event('change',{bubbles:true}));
 });
})();

function initChatBounce(attempt=0) {
 const chat=document.querySelector('shopify-chat');
 const runtime=chat?.shadowRoot?.querySelector('shopify-agent-runtime');
 const button=runtime?.shadowRoot?.querySelector('[part~="activator"]');

 if(!button){
  if(attempt<60){
   setTimeout(()=>initChatBounce(attempt+1),200);
  }
  return;
 }

 const update=()=>{
  const isOpen=button.getAttribute('aria-expanded')==='true';
  chat.style.setProperty(
   '--lumaia-chat-animation',
   isOpen?'none':'lumaia-chat-bounce'
  );
 };

 new MutationObserver(update).observe(button,{
  attributes:true,
  attributeFilter:['aria-expanded']
 });

 update();
}

initChatBounce();

/* Page Nayvo : activer une mise en page sans défilement extérieur */
if (window.location.pathname.replace(/\/$/, '') === '/a/withdrawal') {
  document.body.classList.add('lumaia-withdrawal-page');
}

/* LUMAÏA — Pop-up précommandes */
(() => {
  if (document.body.dataset.template !== 'index') return;

  const storageKey = 'lumaia-preorder-2026';
  if (sessionStorage.getItem(storageKey) === 'seen') return;

  
const targetDate = new Date('2026-12-07T10:00:00-04:00').getTime();
const endDate = new Date('2026-12-08T00:00:00-04:00').getTime();

if (Date.now() >= endDate) return;
  let timer = null;
  let opened = false;

  const overlay = document.createElement('div');
  overlay.className = 'lumaia-preorder-overlay';
  overlay.innerHTML = `
    <section class="lumaia-preorder" role="dialog"
      aria-modal="true" aria-labelledby="lumaia-preorder-title">

      <button class="lumaia-preorder-close" type="button"
        aria-label="Fermer">×</button>

      <p class="lumaia-preorder-eyebrow">
        LES REINES LUMAÏA — PRÉCOMMANDES
      </p>

      <h2 id="lumaia-preorder-title">
        Une création se prépare pour toi.
      </h2>

      <p class="lumaia-preorder-text">
  Les précommandes sont ouvertes.
  Réserve dès maintenant la création qui te ressemble.
  Les premières livraisons débuteront à partir du 7 décembre.
</p>

      <p class="lumaia-preorder-caption">
        PREMIÈRES LIVRAISONS PRÉVUES DANS
      </p>

      <div class="lumaia-preorder-countdown"
        role="timer" aria-label="Temps restant avant les précommandes">
        <div><strong data-preorder-days>00</strong><span>JOURS</span></div>
        <div><strong data-preorder-hours>00</strong><span>HEURES</span></div>
        <div><strong data-preorder-minutes>00</strong><span>MIN</span></div>
        <div><strong data-preorder-seconds>00</strong><span>SEC</span></div>
      </div>

      <p class="lumaia-preorder-date">
        7 décembre 2026 · 10h00 (Martinique)
      </p>
    </section>
  `;

  
function updateCountdown() {
  const now = Date.now();

  // 8 décembre à minuit : fermeture définitive.
  if (now >= endDate) {
    closePopup();
    return;
  }

  // 7 décembre à 10h : message de remerciement.
  if (now >= targetDate) {
    const title = overlay.querySelector(
      '#lumaia-preorder-title'
    );
    const description = overlay.querySelector(
      '.lumaia-preorder-text'
    );
    const caption = overlay.querySelector(
      '.lumaia-preorder-caption'
    );
    const countdown = overlay.querySelector(
      '.lumaia-preorder-countdown'
    );
    const date = overlay.querySelector(
      '.lumaia-preorder-date'
    );

    title.textContent = 'Une belle aventure commence.';
    description.textContent =
      'Merci à toutes celles qui ont précommandé une création Lumaïa. ' +
      'Vos commandes commencent à être préparées dès aujourd’hui, ' +
      'avec tout le soin qu’elles méritent.';

    caption.hidden = true;
    countdown.hidden = true;
    date.textContent = 'MERCI DE FAIRE PARTIE DE L’AVENTURE.';
    date.classList.add('lumaia-preorder-thanks');

    return;
  }

  // Avant le 7 décembre à 10h : compte à rebours.
  const remaining = Math.max(
    0,
    Math.floor((targetDate - now) / 1000)
  );

  const values = [
    Math.floor(remaining / 86400),
    Math.floor((remaining % 86400) / 3600),
    Math.floor((remaining % 3600) / 60),
    remaining % 60
  ];

  ['days', 'hours', 'minutes', 'seconds'].forEach(
    (unit, index) => {
      overlay.querySelector(
        `[data-preorder-${unit}]`
      ).textContent = String(values[index]).padStart(2, '0');
    }
  );
}


  function closePopup() {
    clearInterval(timer);
    timer = null;
    overlay.remove();
    document.removeEventListener('keydown', onKeydown);
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closePopup();
  }

  function openPopup() {
    if (opened || sessionStorage.getItem(storageKey) === 'seen') return;
    opened = true;
    sessionStorage.setItem(storageKey, 'seen');

    document.body.append(overlay);
    updateCountdown();
    timer = setInterval(updateCountdown, 1000);

    overlay.querySelector('.lumaia-preorder-close').focus();
    document.addEventListener('keydown', onKeydown);
  }

  overlay.addEventListener('click', event => {
    if (
      event.target === overlay ||
      event.target.closest('.lumaia-preorder-close')
    ) {
      closePopup();
    }
  });

  const curtain = document.querySelector('.arrival-curtain');

  if (curtain) {
    curtain.addEventListener('animationend', () => {
      setTimeout(openPopup, 800);
    }, { once: true });

    // Sécurité si l'animation ne se termine pas normalement.
    setTimeout(openPopup, 5800);
  } else {
    setTimeout(openPopup, 800);
  }
})();
